// ABOUTME: True when the viewport is under 760px wide, where the v28 shell docks the card and shortens the header.
// ABOUTME: One query shared by the header, the tips pill and the console card.

import { useMediaQuery } from '@mui/material';

export function usePhoneLayout(): boolean {
  return useMediaQuery('(max-width:759.95px)');
}
